import { TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import React, { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getDotFormatDateFns } from 'Util/DateUtils';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ko, vi } from 'date-fns/locale';

const customFieldStyle = {
  '& .MuiOutlinedInput-root': {
    fieldset: {
      border: 'none',
      padding: 0,
    },
  },
  '& .MuiInputBase-input': {
    border: 'none',
    fontSize: '16px',
    padding: '12px 15px',
    fontWeight: '400',
    fontFamily: 'Pretendard',
    cursor: 'pointer',
    '&::placeholder': {
      color: '#999',
      fontSize: '16px',
      fontWeight: '400',
      fontFamily: 'Pretendard',
      opacity: 1,
    },
  },
};

const DateForm = ({ value, onChange, placeholder }) => {
  const { locale } = useSelector(state => state.settings.locale);
  const inputRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { formatMessage } = useIntl();

  return (
    <div className="field-update-date-form">
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale === 'vi' ? vi : ko}>
        <DatePicker
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => setOpen(false)}
          inputFormat={getDotFormatDateFns(locale)}
          value={value}
          onChange={e => {
            onChange({ value: e });
            setOpen(false);
          }}
          components={{
            OpenPickerIcon: () => null,
          }}
          PopperProps={{
            anchorEl: inputRef.current,
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 10],
                },
              },
            ],
          }}
          renderInput={params => (
            <TextField
              {...params}
              sx={{
                ...customFieldStyle,
              }}
              inputProps={{
                ...params.inputProps,
                placeholder: formatMessage({ id: placeholder }),
                readOnly: true,
              }}
              onClick={() => {
                setOpen(true);
              }}
              fullWidth
              inputRef={inputRef}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
};

export default DateForm;
